<template>
  <div class="checkout-item-terms" @click="acceptTerms">
    <input
      :checked="accepted"
      type="checkbox"
      style="pointer-events: none"
      @click="acceptTerms"
    />
    <span>
      <small>
        By checking this box, you agree that you have read and understand the
        the terms of sale for this product*
      </small>
    </span>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: {
    terms: {
      required: true,
      type: String,
    },
    accepted: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    acceptTerms() {
      if (this.accepted) {
        this.$emit("updateTerms", false);
      } else {
        swal
          .fire({
            title: "Review and accept terms",
            customClass: "terms-alert",
            html: `<div><div class="terms-display">${this.terms}</div></div>`,
            showCancelButton: true,
            confirmButtonText: "Yes, I accept",
            confirmButtonColor: "#5cb85c",
            cancelButtonText: "No, I do not accept",
            cancelButtonColor: "#d9534f",
          })
          .then((result) => {
            if (result.value) {
              this.$emit("updateTerms", true);
            } else if (result.dismiss) {
              this.$emit("updateTerms", false);
            } else {
              this.$emit("updateTerms", false);
            }
          });
      }
    },
  },
};
</script>

<style>
.checkout-item-terms {
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  cursor: pointer;
}

.checkout-item-terms input {
  margin: 10px;
}

.checkout-item-terms span {
  margin: auto 1rem;
}

.terms-alert {
  width: 500px;
  max-width: 90vw;
  padding: 1.5rem;
}

.terms-alert div {
  max-height: 65vh;
}

.terms-display {
  text-align: left;
  overflow-y: scroll;
}

.terms-display ul {
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-right: 2rem;
}

.terms-display ul li {
  font-size: 1.5rem;
  padding-bottom: 0.5rem;
}
</style>
